import React from 'react';

const FlexibleHeaderPlaceholder = () => {
  return (
    <div className="placeholder-header color-white">
      <div className="placeholder-row placeholder-header__burger--small animation" />
      <div className="placeholder-row placeholder-header__logo--small animation" />
      <div className="placeholder-row placeholder-header__button--small animation" />
    </div>
  );
};

export default FlexibleHeaderPlaceholder;
